<p-table
  [value]="data()"
  [dataKey]="dataKey()"
  [styleClass]="tableClass()"
  [selection]="selection()"
  [expandedRowKeys]="expandedRows()"
  [rowHover]="rowHover()"
  [loading]="loading()"
  [attr.aria-busy]="loading()"
  (selectionChange)="selection.set($event)"
>
  <ng-template #header>
    <tr>
      @if (selectable()) {
        <th scope="col"><p-tableHeaderCheckbox /></th>
      }
      @if (expandable()) {
        <th scope="col"></th>
      }
      @for (col of columns(); track col.field) {
        <th scope="col" [style.width]="col.width">
          <div class="ps-table-header-label">
            {{ col.header }}
            @if (col.sortable) {
              <ps-icon
                [pSortableColumn]="col.field"
                class="sort-icon"
                name="sort"
                size="sm"
              />
            }
          </div>
        </th>
      }
    </tr>
  </ng-template>

  <ng-template #body let-row let-expanded="expanded">
    <tr>
      @if (selectable()) {
        <td>
          <p-tableCheckbox [value]="row" />
        </td>
      }
      @if (expandable()) {
        <td>
          <button
            type="button"
            [pRowToggler]="row"
            class="ps-table-expander"
            [attr.aria-label]="expanderLabel(expanded)"
            [attr.aria-expanded]="expanded"
          >
            <ps-icon
              [name]="expanderIcon(expanded)"
              size="sm"
              aria-hidden="true"
            />
          </button>
        </td>
      }
      @for (col of columns(); track col.field) {
        <td>
          @if (cellTemplate(); as tmpl) {
            <ng-container
              *ngTemplateOutlet="tmpl; context: { $implicit: row, col: col }"
            />
          } @else if (col.badge) {
            <ps-badge>{{ row[col.field] }}</ps-badge>
          } @else {
            {{ row[col.field] }}
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template #expandedrow let-row>
    <tr>
      <td [attr.colspan]="colSpan()">
        @if (expansionTemplate(); as tmpl) {
          <ng-container *ngTemplateOutlet="tmpl; context: { $implicit: row }" />
        }
      </td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td [attr.colspan]="colSpan()" aria-live="polite">
        {{ emptyMessage() }}
      </td>
    </tr>
  </ng-template>
</p-table>
